import styled from "@emotion/styled";

 export const CardWrapper = styled.div`
 box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
 border-radius:6px;
 padding:10px;
`;